// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { Environment } from './../environments/environment';
import HttpService from 'src/lib/HttpService';

const DEFAULT_USER_TIER_URL = `usertier`;
const USERINFO_URL = `api/graph/v1.0/users`;
const INVITATION_URL = `api/graph/v1.0/invitations`;
const ADD_TO_GROUP_URL = `api/graph/v1.0/groups`;
const GRAPHAPI_DIRECTORY_URL = Environment.getEnvironment.graphApiDirectoryUrl;

async function get(endpoint: string) {
    return await call('get', endpoint);
}

async function del(endpoint: string) {
    return await call('delete', endpoint);
}

async function post(endpoint: string, body?: any) {
    return await call('post', endpoint, body);
}

async function call(method: string, endpoint: string, body?: any) {
    const url = endpoint;
    return await HttpService.proxiedApiCall({
        body,
        requestUrl: url,
        type: method,
    });
}

export default {
    async checkAndGetAadUserId(userEmailAddress: string) {
        try {
            const path = `${USERINFO_URL}/?$filter=mail eq '${userEmailAddress}'`;
            const getUserIdResponse = await get(path);
            return getUserIdResponse;
        }
        catch (e) {
            return e;
        }
    },

    async checkUserInvitationStatus(userId: string) {
        try {
            const path = `${USERINFO_URL}/${userId}?$select=externalUserState`;
            const getUserResponse = await get(path);
            return getUserResponse;
        }
        catch (e) {
            return e;
        }
    },

    async addUserToGroup(userId: string) {
        try {
            const body = {
                '@odata.id': `${GRAPHAPI_DIRECTORY_URL}/${userId}`,
            };
            const path = `${ADD_TO_GROUP_URL}/GRAPHAPI_GROUP_ID/members/$ref`;
            const addToGroupResponse = await post(path, body);
            return addToGroupResponse;
        }
        catch (e) {
            return e;
        }
    },

    async deleteUserFromGroup(userId: string) {
        try {
            const path = `${ADD_TO_GROUP_URL}/GRAPHAPI_GROUP_ID/members/${userId}/$ref`;
            const deleteFromGroupResponse = await del(path);
            return deleteFromGroupResponse;
        }
        catch (e) {
            return e;
        }
    },

    async sendAadInvitation(request: any) {
        try {
            const body = request;
            body.inviteRedirectUrl = '';
            const path = `${INVITATION_URL}`;
            const sendInvitationResponse = await post(path, body);
            return sendInvitationResponse;
        }
        catch (e) {
            return e;
        }
    },

    async addUserToRoboDB(request: any) {
        try {
            const body = {
                retailUser: request,
            };
            const path = `${DEFAULT_USER_TIER_URL}/create`;
            const addToDBResponse = await post(path, body);
            return addToDBResponse;
        }
        catch (e) {
            return e;
        }
    },

    async deleteUserFromDB(request: any) {
        try {
            const body = {
                deleteUserPayload: request,
            };
            const path = `${DEFAULT_USER_TIER_URL}/delete`;
            const deleteFromDBResponse = await post(path, body);
            return deleteFromDBResponse;
        }
        catch (e) {
            return e;
        }
    },
};
